import {
  DeliveryType,
  PaymentMode,
  PieceInterface,
  ResponseInterface,
} from "../interfaces";
import { IncidenceActionDTO } from "../interfaces/Dtos/IncidenceActionDTO";
import { IncidenceReasonDTO } from "../interfaces/Dtos/IncidenceReasonDTO";
import api from "./api";
import axios from "axios";

const baseURL = process.env.REACT_APP_API_HOST;

export const getIncidenceList = async (
  profileID: number,
  applicationID: number
): Promise<ResponseInterface<IncidenceReasonDTO[]>> => {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  const uri = `${baseURL}/v2/Incidence/GetIncidenceList?ProfileID=${profileID}&ApplicationID=${applicationID}`;

  try {
    const response = await api.get(uri, {
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken: source.token,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching incidence list:", error);
  }

  return {
    message: "Error fetching incidence list",
    didError: true,
    errorMessage: "Error fetching incidence list",
    model: null,
  };
};

export const getReasonList = async (
  profileID: number,
  incidenceID: number
): Promise<ResponseInterface<IncidenceReasonDTO[]>> => {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  const uri = `${baseURL}/v2/Incidence/GetReasonList?IncidenceID=${incidenceID}&ProfileID=${profileID}`;

  try {
    const response = await api.get(uri, {
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken: source.token,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching incidence list:", error);
  }

  return {
    message: "Error fetching incidence list",
    didError: true,
    errorMessage: "Error fetching incidence list",
    model: null,
  };
};

export const getIncidenceActionList = async (
  reasonID: number,
  incidenceID: number,
  userLogin: string | undefined
): Promise<ResponseInterface<IncidenceActionDTO[]>> => {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  const uri = `${baseURL}/v2/Incidence/GetActionByIncidence?IncidenceID=${incidenceID}&ReasonID=${reasonID}&UserLogin=${userLogin}&ApplicationID=10`;

  try {
    const response = await api.get(uri, {
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken: source.token,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching incidence list:", error);
  }

  return {
    message: "Error fetching incidence list",
    didError: true,
    errorMessage: "Error fetching incidence list",
    model: null,
  };
};

export const addIncidence = async (
  shipmentID: string,
  shipmentNumber: string,
  incidenceID: number,
  reasonID: number,
  incidenceActionID: number,
  buCode: string,
  pieces: PieceInterface[],
  userLogin: string,
  buCodeHoldAt: string,
  newBUCodeConsignee?: string,
  newPaymentModeID?: PaymentMode,
  newDeliveryTypeID?: DeliveryType,
  consigneeLatitude?: number,
  consigneeLongitude?: number,
  consigneeAddress?: string,
  consigneeAddressLine2?: string,
  consigneeAddressName?: string,
  consigneeAddressLandMark?: string
): Promise<ResponseInterface<number>> => {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  const uri = `${baseURL}/v2/Incidence`;
  const body = JSON.stringify([
    {
      ObjectTypeID: 10,
      ObjectID: shipmentID,
      ObjectGroupID: 0,
      IncidenceID: incidenceID,
      ReasonID: reasonID,
      ActionID: incidenceActionID,
      BUCodeIncidence: buCode,
      Observation: "",
      ShipmentNumber: shipmentNumber,
      CreationUser: userLogin,
      BUCodeHoldAt: buCodeHoldAt,
      Reenrute: {
        oldShipmentNumber: shipmentNumber,
        oldShipmentID: shipmentID,
        reasonID: reasonID,
        updateUser: userLogin,
        buCodeRequest: buCode,
        newBUCodeConsignee,
        newPaymentModeID,
        newDeliveryTypeID,
        consigneeLatitude,
        consigneeLongitude,
        consigneeAddress,
        consigneeAddressLine2,
        consigneeAddressName,
        consigneeAddressLandMark,
      },
    },
    ...pieces.map((piece) => ({
      ObjectTypeID: 13,
      ObjectID: piece.shipmentDetailID,
      ObjectGroupID: 0,
      IncidenceID: incidenceID,
      ReasonID: reasonID,
      ActionID: incidenceActionID,
      BUCodeIncidence: buCode,
      Observation: "",
      CreationUser: userLogin,
      BUCodeHoldAt: buCodeHoldAt,
    })),
  ]);

  try {
    const response = await api.post(uri, body, {
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken: source.token,
    });
    return response.data;
  } catch (error) {
    console.error("Error adding incidence:", error);
  }

  return {
    message: "Error adding incidence",
    didError: true,
    errorMessage: "Error adding incidence",
    model: null,
  };
};
